import State from '../core/State';

export const startSpinner = () => (state: State): State => ({
  ...state,
  fullScreenSpinner: {
    ...state.fullScreenSpinner,
    necessity: state.fullScreenSpinner.necessity + 1,
  },
});

export const finishSpinner = () => (state: State): State => ({
  ...state,
  fullScreenSpinner: {
    ...state.fullScreenSpinner,
    necessity: state.fullScreenSpinner.necessity - 1,
  },
});
